/**
 * Formato y etiquetas compartidos por las pestañas de «Costes».
 */
import React from 'react';
import { EXPEDIENT_TYPE_LABELS } from '@claimup/shared/constants/expedient';

const nf = new Intl.NumberFormat('es-ES');
const nf2 = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const nf4 = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 4 });

export const eur = v => (v == null ? '—' : `${nf2.format(v)} €`);
/** Para costes unitarios, que suelen ser de céntimos: hasta 4 decimales. */
export const eurUnit = v => (v == null ? '—' : `${nf4.format(v)} €`);
export const num = v => (v == null ? '—' : nf.format(v));
export const pct = v => (v == null ? '—' : `${v > 0 ? '+' : ''}${nf.format(v)} %`);

export const currentMonth = () => new Date().toISOString().slice(0, 7);

export const monthLabel = m => {
  const [y, mm] = m.split('-').map(Number);
  return new Date(Date.UTC(y, mm - 1, 1)).toLocaleDateString('es-ES', { month: 'long', year: 'numeric', timeZone: 'UTC' });
};

export const VOLUME_LABELS = {
  dials: 'marcaciones',
  answered: 'contestadas',
  useful: 'útiles (≥ 45 s)',
  human: 'con persona',
  expedients: 'expedientes',
  sent: 'enviados',
  delivered: 'entregados',
  estimated: 'con precio estimado',
  replies: 'respuestas',
  billable: 'cobrados por Meta',
  plans: 'planes',
  approved: 'aprobados',
  rejected: 'rechazados',
  retries: 'reintentos',
};

export const LINE_OPTIONS = [
  { value: '', label: 'Todas las líneas' },
  { value: 'extra-judicial', label: EXPEDIENT_TYPE_LABELS['extra-judicial'] },
  { value: 'account-receivable', label: EXPEDIENT_TYPE_LABELS['account-receivable'] },
  { value: 'judicial', label: 'Judicial' },
];

export const Tile = ({ label, value, sub, tone = 'text-slate-800' }) => (
  <div className='bg-white border border-slate-200 rounded-lg px-4 py-3'>
    <div className='text-xs text-slate-500'>{label}</div>
    <div className={`text-xl font-semibold mt-1 ${tone}`}>{value}</div>
    {sub && <div className='text-xs text-slate-500 mt-0.5'>{sub}</div>}
  </div>
);

export const Box = ({ title, children, right }) => (
  <section className='bg-white border border-slate-200 rounded-lg'>
    {title && (
      <div className='px-4 py-3 border-b border-slate-100 flex items-center justify-between gap-3'>
        <h2 className='font-semibold text-slate-800 text-sm'>{title}</h2>
        {right}
      </div>
    )}
    <div className='p-4'>{children}</div>
  </section>
);

export const Loading = () => <div className='bg-white border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-400'>Cargando…</div>;

export const LoadError = ({ what }) => (
  <div className='bg-white border border-rose-200 rounded-lg px-4 py-3 text-sm text-rose-700'>No se ha podido cargar {what}.</div>
);

/** Lo que tuvo volumen y no tiene tarifa: no es gratis, falta el precio. */
export const MissingRates = ({ missing }) => {
  if (!missing?.length) return null;
  return (
    <div className='bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm text-amber-800'>
      <div className='font-medium'>Sin tarifa: estos consumos no están sumados</div>
      <ul className='mt-1 list-disc list-inside'>
        {missing.map(m => (
          <li key={`${m.provider}-${m.concept}-${m.country || ''}-${m.reason}`}>
            {m.provider_label || m.provider} · {m.label || m.concept}
            {m.country ? ` (${m.country})` : ''}: {num(m.quantity)} {m.reason !== 'sin tarifa' ? `— ${m.reason}` : ''}
          </li>
        ))}
      </ul>
      <div className='mt-1 text-xs'>Añádelas en la pestaña Tarifas.</div>
    </div>
  );
};
